module.exports = __webpack_public_path__ + "static/img/badge-trap-scheduled.b3610bf.svg";